import { NOOP } from 'appConstants';
const shouldCallQBApi = process.env.UI_ENV === 'prod';

export const getQBActionOrDummyType = (actionType) =>
  shouldCallQBApi ? actionType : NOOP;
